import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { InputTaskCategory } from 'interfaces/IInputTask';
import { saveTaskCategory } from 'utils/taskCategoryStorage';

import { getActiveTaskCategory } from '../../../../redux/selectors/InputSelectors';
import { setActiveTaskCategory } from '../../../../redux/slices/InputSlice';

/**
 * The Tasks grid's Plan / Actual choice, kept for the browser session
 * (OP-2556): moving to another plan in the tree, even through a paddock with
 * no plan open, keeps it, so someone recording Actuals across paddocks
 * doesn't have to switch back each time. Held in Redux so the copy tool can
 * default to it (OP-2519); the slice loads it from session storage.
 */
export const useRememberedTaskCategory = (): [
  InputTaskCategory,
  (category: InputTaskCategory) => void,
] => {
  const dispatch = useDispatch();
  const taskCategory = useSelector(getActiveTaskCategory);

  const setRememberedTaskCategory = useCallback(
    (category: InputTaskCategory) => {
      dispatch(setActiveTaskCategory(category));
      saveTaskCategory(category);
    },
    [dispatch]
  );

  return [taskCategory, setRememberedTaskCategory];
};
